<div class="loading active" id="loading-init" *ngIf="this.loader.getLoading()">
  <div class="loading-inner">
      <div class="page-spinner"></div><span>Cargando...</span>
  </div>
</div>
